import { z } from "zod"; 
 
const defaultEmptyMessage = { 
  message: "Обязательное поле", 
}; 
 
const ProjectSectionSchema = z.object({ 
  name: z.string().optional(), 
  number: z.string().optional(), 
}); 
 
export default z 
  .object({ 
    name: z 
      .string(defaultEmptyMessage) 
      .max(48, { message: "Название слишком большое" }), 
    number: z 
      .string(defaultEmptyMessage) 
      .refine((r) => r, { message: "Обязательно" }), 
    issueDate: z.preprocess( 
      (val) => { 
        if (typeof val === "string") return new Date(val); 
        if ( 
          val && 
          typeof val === "object" && 
          "toDate" in val && 
          typeof (val as { toDate: unknown }).toDate === "function" 
        ) { 
          return (val as { toDate: () => Date }).toDate(); // dayjs object 
        } 
        return val; 
      }, 
      z.date({ 
        required_error: "Обязательное поле", 
        invalid_type_error: "Неверная дата", 
      }), 
    ), 
    permit: z.preprocess( 
      (f) => { 
        if (f && typeof f === "object" && "fileList" in f && Array.isArray(f.fileList)) { 
          return f.fileList?.[0]?.originFileObj; 
        } 
        return null; 
      }, 
      z.instanceof(File, defaultEmptyMessage), 
    ), 
    organization: z.string().optional(), 
    description: z.string().optional(), 
    projectSections: z.array(ProjectSectionSchema).optional(), 
    type: z.enum(["author", "settings"]).optional(), 
  }) 
  .superRefine((data, ctx) => { 
    if (data.type !== "author") { 
      return; 
    } 
 
    const sections = data.projectSections ?? []; 
 
    if (sections.length === 0) { 
      ctx.addIssue({ 
        path: ["projectSections"], 
        code: z.ZodIssueCode.custom, 
        message: "Добавьте хотя бы один раздел", 
      }); 
      return; 
    } 
 
    sections.forEach((section, index) => { 
      if (!section.name?.trim()) { 
        ctx.addIssue({ 
          path: ["projectSections", index, "name"], 
          code: z.ZodIssueCode.custom, 
          message: "Укажите раздел", 
        }); 
      } 
 
      if (!section.number?.trim()) { 
        ctx.addIssue({ 
          path: ["projectSections", index, "number"], 
          code: z.ZodIssueCode.custom, 
          message: "Укажите номер", 
        }); 
      } 
    }); 
  });
